import EmptyStateGraphic from "./EmptyStateGraphic";

export default EmptyStateGraphic 


// WEBPACK FOOTER //
// ./src/components/EmptyStateGraphic/index.jsx